import React, { Component } from 'react';
import './index.scss';
import {Link } from "react-router-dom"

import settlepic1 from '../../../../assets/app/about/settle/settle-1.png'
import settlepic2 from '../../../../assets/app/about/settle/settle-2.png'
import settlepic3 from '../../../../assets/app/about/settle/settle-3.png'
import settlepic4 from '../../../../assets/app/about/settle/settle-4.png'
import settlepic5 from '../../../../assets/app/about/settle/settle-5.png'
import settlepic6 from '../../../../assets/app/about/settle/settle-6.png'


class Settle extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  
  componentDidMount(){
  }

  render() {
    return (
      <div className="imageBlock">
          {/* <p style={{paddingLeft:'5%',fontSize:24,paddingTop:10 }}>详情页</p> */}
          <img src={settlepic1} className="backgroundbg"/>
          <img src={settlepic2} className="backgroundbg"/>
          <img src={settlepic3} className="backgroundbg"/>
          <img src={settlepic4} className="backgroundbg"/>    
          <img src={settlepic5} className="backgroundbg"/>
          <img src={settlepic6} className="backgroundbg"/>
      </div>
    );
  }
}

export default Settle;
